// GENERATED by scripts/write-build-env.mjs at build time — do not edit.
// Values come from the VITE_* environment of the build (see .env.example / CI).
export const SITE = "https://www.hrmless.com";
export const SIGN_IN_URL = "https://nervai.hrmless.com/";
export const TRUST_CENTER_URL = "https://trust.hrmless.com/";
export const KEYCLOAK_ISSUER = "https://login.hrmless.com/realms/nervai";
export const KOMBINATION_OPENAPI_URL = "https://kombination.hrmless.com/openapi.json";
